export enum RefreshTokenState {
  Idle,
  TokenRefreshInProgress,
  TokenRefreshFailed,
}
